var _style, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconDeactiveStore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 87.4 83.9",
    style: {
      enableBackground: "new 0 0 87.4 83.9"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#6761EA;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M84.3,77.6h-9.4V43.2h1.6c2.1,0,4-1,5.2-2.7s1.4-3.9,0.6-5.8l-4.5-11.3c-0.5-1.2-1.6-2-2.9-2h-6.2 c-1.7,0-3.1,1.4-3.1,3.1s1.4,3.1,3.1,3.1h4.1l3.7,9.4h-4.8H15.5l0,0l0,0h-4.7l3.7-9.4h4.2c1.7,0,3.1-1.4,3.1-3.1s-1.4-3.1-3.1-3.1 h-6.2c-1.3,0-2.4,0.8-2.9,2L5.1,34.8c-0.8,1.9-0.5,4.1,0.6,5.8c1.2,1.7,3.1,2.7,5.2,2.7h1.6v34.4H3.1c-1.7,0-3.1,1.4-3.1,3.1 s1.4,3.1,3.1,3.1h81.2c1.7,0,3.1-1.4,3.1-3.1S86,77.6,84.3,77.6z M18.7,43.2h50v34.4h-6.2v-25c0-1.7-1.4-3.1-3.1-3.1H28.1 c-1.7,0-3.1,1.4-3.1,3.1v25h-6.3V43.2z M56.2,77.6h-25V55.7h25V77.6z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M56.3,9.5l-4.5,4.4l4.5,4.4c0.5,0.5,0.9,1.1,1.2,1.8c0.3,0.7,0.4,1.4,0.4,2.1s-0.1,1.5-0.4,2.1 c-0.3,0.7-0.7,1.3-1.2,1.8s-1.1,0.9-1.8,1.2s-1.4,0.4-2.1,0.4c-0.7,0-1.5-0.1-2.1-0.4c-0.7-0.3-1.3-0.7-1.8-1.2l-4.4-4.5l-4.4,4.5 c-0.5,0.5-1.1,0.9-1.8,1.2s-1.4,0.4-2.1,0.4c-0.7,0-1.5-0.1-2.1-0.4c-0.7-0.3-1.3-0.7-1.8-1.2S31,25,30.7,24.3s-0.4-1.4-0.4-2.1 c0-0.7,0.1-1.5,0.4-2.1c0.3-0.7,0.7-1.3,1.2-1.8l4.5-4.4l-4.5-4.4c-1.1-1.1-1.6-2.5-1.6-4c0-0.7,0.1-1.5,0.4-2.1 c0.3-0.7,0.7-1.3,1.2-1.8C33,0.5,34.4,0,35.9,0c0.7,0,1.5,0.1,2.1,0.4c0.7,0.3,1.3,0.7,1.8,1.2l4.4,4.5l4.4-4.5 c0.5-0.5,1.1-0.9,1.8-1.2S51.8,0,52.5,0s1.5,0.1,2.1,0.4c0.7,0.3,1.3,0.7,1.8,1.2s0.9,1.1,1.2,1.8C57.9,4.1,58,4.8,58,5.5 c0,0.7-0.1,1.5-0.4,2.1C57.3,8.4,56.9,9,56.3,9.5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDeactiveStore);
export default __webpack_public_path__ + "static/media/icon_deactive_store.963f3242625d9a44ad5e5a5e1100e1da.svg";
export { ForwardRef as ReactComponent };